export default __webpack_public_path__ + "static/media/air-now-logo.c4fec8f5.svg";